
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WLProductContext extends Vue {
  @Prop()
  private context!: string;

  private i18n: any;

  public async created() {
    this.i18n = {
      title: this.$t('product_page.title_seo'),
    };
  }
}
